// extracted by mini-css-extract-plugin
export default {"paymentDetails":"hoDRwlj","heading":"sA0S480","paragraph":"UH6gumx","link":"_rH0Jwq"};